/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import survey from '../../../context/survey';
import sendRAT, { ACTION, SCREEN } from '../../../app/rat';
import Nps from '../../nps/Nps';
import surveyState from '../../../app/surveyState';
import { fadeInUpComponent } from '../style';
import { Broadcast, Init } from '../../../../../embedded-type/broadcast';
// import Permission from '../../permission/Permission';

const FadeinNpsComponent = fadeInUpComponent(Nps);

/**
 * widget Nps
 * - index < step の時にも rendering しますが表示しない（見えない）ようにします
 * @param {number} index 表示順序 config.step 等価の時に表示します
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} [embedded=false] embedded flag
 * @param {*} [nps={}] Redux.store.nps - Nps 状態を保持します
 * @return {*} React.node
 * @constructor
 */
const WidgetNps = ({ index, state, dispatch, embedded = false, nps = {} }) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);

  const { config, step } = state;

  const timerId = useRef(0);

  // delay (100ms) し次 widget へ移動します
  const nextScene = useCallback(
    (checked, name, value) => {
      state.type = survey.events.UPDATE;
      state.step = index + 1;
      // checked value, name を state へ
      state.config.nps.checked = checked;
      state.nps.name = name;
      state.nps.value = value;
      dispatch(state);
    },
    [state, dispatch, index]
  );

  // unmount 時に timer id clearTimeout します
  const cleanupWithUnmount = useCallback(() => {
    clearTimeout(timerId.current);
  }, [timerId]);

  // will unmount
  useEffect(() => {
    return cleanupWithUnmount;
  }, [cleanupWithUnmount]);

  // did update
  useEffect(() => {
    if (step === index && (!nps.meta || !nps.meta.appear)) {
      // RAT for appear
      sendRAT({
        cId: config.cId.value,
        screen: SCREEN.NPS,
        action: ACTION.APPEAR,
      });
      // ---
      if (nps.meta) {
        Broadcast.nps.appear();
        setTimeout(Init.nps, 16);
      }
    }
  }, [step, config.cId.value, index, nps]);

  // const hidden = step > index ? 'Nps-hidden' : '';
  const hiddenClass = useCallback(() => {
    return step > index ? 'Nps-hidden' : '';
  }, [step, index]);

  const onCloseClick = useCallback(() => {
    // sendRAT - cId, screen: SCREEN.NPS `nps`, action: ACTION.CLOSE `close`
    sendRAT({
      cId: config.cId.value,
      screen: SCREEN.NPS,
      action: ACTION.CLOSE,
    });
    // /rexsurvey_save_state=false/.test(window.location.search) === false -> 「Surveyへの回答を拒否した」という状態をLocalStorageに保存する - declineSurvey
    if (surveyState.shouldStoreState()) {
      surveyState.storeDecline(
        config.expirationPeriod,
        config.enableDisplaySuppressionPerPage
      );
    }
    // close all - step: -1
    state.type = survey.events.UPDATE;
    state.step = -1;
    dispatch(state);
  }, [state, dispatch, config]);

  const onChange = useCallback(
    event => {
      const { target } = event;
      const value = parseInt(target.dataset.index, 10);
      // sendRAT - cId, screen: SCREEN.NPS `nps`, action: ACTION.ANSWER `answer`
      sendRAT({
        cId: config.cId.value,
        screen: SCREEN.NPS,
        action: ACTION.ANSWER,
      });
      if (!embedded) {
        // 100ms delay next scene
        timerId.current = setTimeout(() => {
          nextScene(value, target.name, target.value);
        }, 100);
      } else {
        // embedded type
        Broadcast.nps.change({
          checked: value,
          name: target.name,
          value: target.value,
        });
      }
    },
    [config, timerId, nextScene, embedded]
  );

  // component 選択します
  // index: 0 - static / animation (fadeInUp)
  const NpsComponent = index === 0 ? Nps : FadeinNpsComponent;
  // console.log('WidgetNps - step / index', step, index);
  return (
    step >= index && (
      <NpsComponent
        className={hiddenClass()}
        message={state.config.nps.question.label}
        minScoreLabel={state.config.nps.txt0}
        maxScoreLabel={state.config.nps.txt1}
        name={state.config.nps.options[0].name}
        optionValues={state.config.nps.options}
        config={state.config}
        onCloseClick={onCloseClick}
        onChange={onChange}
        state={state}
        dispatch={dispatch}
        embedded={embedded}
      />
    )
  );
};

export default WidgetNps;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/sequences/WidgetNps.js